/* Shipping protection toggle for the cart drawer.

   El interruptor se mueve al instante y la peticion va detras. Un toggle que
   tarda 800 ms en responder se siente roto: el cliente vuelve a pulsar, y
   entonces si que se rompe. Se pinta primero y se corrige despues si el
   servidor dice otra cosa.

   La verdad del servidor NO es aria-checked (que ya esta pintado de forma
   optimista) sino data-line-key: el snippet solo lo rellena cuando la linea
   existe de verdad en el carrito.

   El carrito se repinta con la Section Rendering API, que /cart/add.js y
   /cart/change.js devuelven en la misma peticion. Asi el contador, la barra
   de tramos y los totales quedan al dia con una sola ida y vuelta. */

(function () {
  'use strict';

  var SECTION = 'cart-drawer-section';

  var inFlight = false;

  // Ultimo estado que ha pedido el cliente. null = nada pendiente.
  var intent = null;

  function el() {
    return document.querySelector('[data-dn-protect-toggle]');
  }

  // Lo que el carrito tiene de verdad ahora mismo.
  function serverOn() {
    var b = el();
    return !!(b && b.dataset.lineKey);
  }

  function paint(on) {
    var b = el();
    if (!b) return;
    b.classList.toggle('is-on', !!on);
    b.setAttribute('aria-checked', on ? 'true' : 'false');
  }

  function redraw(html) {
    if (!html) return false;

    var fresh = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('.cart-drawer__inner');
    var live = document.querySelector('.cart-drawer__inner');
    if (!fresh || !live) return false;

    live.replaceWith(fresh);
    bind(document);

    // Los widgets del tema (carrusel, selectores de cantidad) escuchan esto.
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    return true;
  }

  function send(want) {
    var b = el();
    if (!b) return;

    inFlight = true;

    // Quitar necesita la clave de linea; anadir necesita el id de variante.
    var url = want ? '/cart/add.js' : '/cart/change.js';
    var payload = want
      ? { items: [{ id: Number(b.dataset.variantId), quantity: 1 }], sections: SECTION }
      : { id: b.dataset.lineKey, quantity: 0, sections: SECTION };

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        inFlight = false;
        redraw(data && data.sections && data.sections[SECTION]);
        pump();
      })
      .catch(function () {
        inFlight = false;
        intent = null;
        // El carrito no ha cambiado: el interruptor vuelve donde estaba.
        paint(serverOn());
      });
  }

  // Manda la peticion que haga falta para que el carrito acabe donde el
  // cliente ha pedido. Si ha pulsado dos veces mientras iba una peticion,
  // esto lanza la segunda en lugar de perderla.
  function pump() {
    if (inFlight || intent === null) return;

    if (intent === serverOn()) {
      intent = null;
      return;
    }

    paint(intent);
    send(intent);
  }

  function bind(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var buttons = scope.querySelectorAll('[data-dn-protect-toggle]');

    Array.prototype.forEach.call(buttons, function (button) {
      if (button.dataset.dnProtectInit === 'true') return;
      button.dataset.dnProtectInit = 'true';

      button.addEventListener('click', function () {
        intent = button.getAttribute('aria-checked') !== 'true';
        paint(intent);
        pump();
      });
    });

    // Si el carrito se ha repintado con una intencion aun pendiente, se
    // vuelve a pintar antes de que el cliente vea el estado viejo.
    if (intent !== null && intent !== serverOn()) paint(intent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind(document);
    });
  } else {
    bind(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });

  document.addEventListener('cart:update', function () {
    window.setTimeout(function () {
      bind(document);
    }, 0);
  });
})();
